// extracted by mini-css-extract-plugin
module.exports = {"styles":"_2cx9oB3jZpAMScSXVDMueN"};